
//接口名称
var api = {
  yzm_login: '/app/Account/yzm_login',//验证码登录
  get_yzm: '/app/Account/yzm',//获取验证码
  upload: '/app/Upload/upload',//上传图片

  agreement: '/app/Account/auth_info',//协议政策
  login: '/app/Account/login',// 账号密码登录



  home: '/app/appindex/index',//首页接口
  my_message: '/app/message/my_message',//系统消息列表
  search: '/app/Invitation/search',//搜索页数据
  my_remind: '/app/Message/my_remind',//提醒接口
  see_remind: '/app/Message/see_remind',//查看提醒 - 销红

  special_index: '/app/Invitation/index',//专区主页

  add_invitation: '/app/Invitation/add_invitation',//发布帖子
  invitation_list: '/app/Invitation/invitation_list',//帖子列表
  invitation_details: '/app/Invitation/invitation_details',//帖子详情
  del_invitation: '/app/Invitation/del_invitation',//删除帖子
  comment_list: '/app/Comment/comment_list',//帖子评论列表
  addComment: '/app/Comment/addComment',//发布评论
  other_index: '/app/invitation/other_index',//他人主页
  my_reply: '/app/member/my_reply',//我的或者他人的回复
  del_reply: '/app/member/del_reply',//删除回复
  like_list: '/app/Invitation/like_list',//点赞列表


  user_index: '/app/member/index',//个人中心
  edit_user: '/app/Member/edit_user',//编辑资料
  verify_yzm: '/app/Account/verify_yzm',//验证手机号
  edit_mobile: '/app/Member/edit_mobile',//修改手机号
  forgetPass: '/app/Account/forgetPass',//修改密码
  my_collect: '/app/member/my_collect',//我的收藏
  history_list: '/app/member/history_list',//我的浏览记录
  del_history: '/app/member/del_history',//删除浏览记录
  fankui_add: '/app/Member/fankui_add',//添加意见反馈
  fankui_type: '/app/Member/fankui_type',//意见反馈分类
  my_fans: '/app/Member/my_fans',//我的粉丝/关注  type: 1我的粉丝，2我的关注
  followFans: '/app/Invitation/join_follow_type',//收藏关注点赞加入帖子分类等
  zone_list: '/app/Address/all_zone_list',//所有省市区列表


  conversation_list: '/app/Message/conversation_list',// 私信列表
  conversation_detail: '/app/Message/conversation_detail',// 私信列表
  send: '/app/Message/send',// 私信列表
  three_login: '/app/Account/three_login',// 三方登录
  join_special: '/app/Member/invitation_type',// 加入的专区

  getOpenid: '/app/Account/getOpenid',// 获取openid
  bang_mobile: '/app/Account/bang_mobile',// 微信qq登录绑定手机号
  get_directory: '/app/Invitation/get_directory',// 获取视屏分类
  report: '/app/Invitation/report',// 举报接口
  create_meeting: '/app/Message/create_meeting',// 创建会话
  message_top_del: '/app/Message/message_top_del',// 删除会话

  pc_config: '/app/appindex/pc_config',// 消息角标
  box_details: '/app/Invitation/box_details',// 草稿箱详情
  getSignPackage: '/app/Wxshare/getSignPackage',// 获取微信分享配置数据



}

export default api;










// WEBPACK FOOTER //
// ./src/api/api.js